import React, { useCallback, useEffect, useState } from "react";
import style from "./Users.module.scss";
import Search from "../../components/search";
import { LinearLoader } from "../../components/Loader/LinearLoader";
import Pagination from "../../components/paginationCopy/Pagination";
import { Table } from "react-bootstrap";
import axiosClient from "../../service/axios";
import { pipeAlert } from "../../components/NotificationToast";

const Pipeline = () => {
  const [pipelines, setPipelines] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  const getPipelines = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axiosClient.get(
        "/lite/v2/api/admin/pipeline/hospital"
      );
      setPipelines(data.data);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    getPipelines();
  }, [getPipelines]);

  const handleAdd = async (id) => {
    const data = { hospital_id: id };
    setLoading(true);
    try {
      const res = await axiosClient.post("/lite/v2/api/admin/pipeline/add", data);
      if (res.status === 200) {
        pipeAlert();
        setLoading(false);
      }
    } catch (error) {
      if (error.response.status === 400) {
        alert(error.response.data.message);
        setLoading(false);
      }
    }
  };

  const headers = [
    { key: "index", label: "S/N" },
    { key: "name", label: "Name" },
    { key: "date", label: "Date" },
    { key: "state", label: "Address" },
  ];

  // pagination
  const [pageNumber, setPageNumber] = useState(0);
  const size = 10;
  const pagesVisited = pageNumber * size;
  const pageCount = Math.ceil(pipelines?.length / size);

  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  useEffect(() => {
    setPageNumber(0);
  }, [search]);

  const filteredData = pipelines?.filter((item) =>
    item?.name?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
      <div className="d-flex justify-content-between m-3">
        <div></div>
        <Search placeholder="Find a hospital" onChange={(event) => setSearch(event.target.value)} />
      </div>
      <section style={{ maxWidth: "95%", margin: "auto" }}>
        {loading && <LinearLoader />}
        <Table borderless responsive className="mt-4">
          <thead>
            <tr className={style.TableHeadRow}>
              {headers.map((row) => {
                return <td key={row.key}>{row.label} </td>;
              })}
            </tr>
          </thead>
          {filteredData.length > 0 ? (
            <tbody>
              {filteredData
                ?.slice(pagesVisited, pagesVisited + size)
                ?.map((pipeline) => (
                  <tr className={style.tableBodyRow} key={pipeline.id}>
                    <td style={{ width: "20vw" }}>{pipeline.id}</td>
                    <td style={{ width: "20vw" }}>{pipeline.name}</td>
                    <td style={{ width: "20vw" }}>{pipeline.created_at}</td>
                    <td style={{ width: "20vw" }}>{pipeline.state}</td>
                    <td className="d-flex gap-3 justify-content-center align-items-center">
                      <button className={style.button} onClick={() => handleAdd(pipeline.id)}>{loading ? "initiating..." : "initiate"}</button>
                    </td>
                  </tr>
                ))}
            </tbody>
          ) : (
            <tbody>
              <tr>
                <td colSpan={headers.length}>No data found</td>
              </tr>
            </tbody>
          )}
        </Table>
        {filteredData?.length > size && (
          <Pagination pageCount={pageCount} onPageChange={changePage} />
        )}
      </section>
    </>
  );
};

export default Pipeline;
